<span class="text-m itx-tooltip-element link-line" *ngIf="linetermsMessage" [textContent]="linetermsMessage"> </span>

<div class="new-tooltip rgpd-tooltip">
    <div class="new-tooltip-arrow bottom-arrow"></div>

    <div class="dialog-content ma-rgpd new-tooltip-inner">
        <div class="ma-modal-header text-center">
            <h4>{{ 'rgpd.titlePopup' | translate }}</h4>
        </div>

        <div class="ma-modal-content">
            <ul>
                <li>
                    <span class="rgpd-title text-l" [textContent]="termsData.common.title1"></span>
                    <span class="rgpd-content text-l" [textContent]="termsData.layer.content1"></span>
                    <a href="{{ termsData.links.controller }}" target="_blank">{{ termsData.common.link }}</a>
                </li>
                <li>
                    <span class="rgpd-title text-l" [textContent]="termsData.common.title2"></span>
                    <span class="rgpd-content text-l" [textContent]="termsData.layer.content2"></span>
                    <a href="{{ termsData.links.use }}" target="_blank">{{ termsData.common.link }}</a>
                </li>
                <li>
                    <span class="rgpd-title text-l" [textContent]="termsData.common.title3"></span>
                    <span class="rgpd-content text-l" [textContent]="termsData.layer.content3"></span>
                    <a href="{{ termsData.links.ground }}" target="_blank">{{ termsData.common.link }}</a>
                </li>
                <li>
                    <span class="rgpd-title text-l" [textContent]="termsData.common.title4"></span>
                    <span class="rgpd-content text-l" [textContent]="termsData.layer.content4"></span>
                    <a href="{{ termsData.links.rights }}" target="_blank">{{ termsData.common.link }}</a>
                </li>
                <li>
                    <span class="rgpd-title text-l" [textContent]="termsData.common.title5"></span>
                    <span class="rgpd-content text-l" [textContent]="termsData.common.content5"></span>
                    <a href="{{ termsData.links.policy }}" target="_blank">{{ 'privacy_policy' | translate }}</a>
                </li>
            </ul>
        </div>
    </div>
</div>
